import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import getLocalized from 'utils/get-localized';
import { StyledSubTabTitleWrapper, StyledCover } from './StyledComponents';

/*
 * This is just a wrapper for props validation.
 * Not used directly inside "SubTabPanel" render
 */
export const SubTabWrapper = () => null;

SubTabWrapper.propTypes = {
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const SubTab = props => {
  const { item, index, id, onFocus, onEnter, isActive } = props;
  const title = getLocalized(item.titles, item.title);
  const { imageUrl } = item;

  const onItemEnter = useCallback(() => onEnter(index), [onEnter, index]);

  const content = imageUrl ? <StyledCover cover={imageUrl} /> : title;

  return (
    <StyledSubTabTitleWrapper
      id={id}
      index={index}
      className={isActive ? 'active' : ''}
      onFocus={onFocus}
      onEnter={onItemEnter}
    >
      {content}
    </StyledSubTabTitleWrapper>
  );
};

SubTab.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  onFocus: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default memo(SubTab);
